const languageEnum = {
  PT: "pt_pt",
  EN: "en_us",
  BR: "pt_br",
};

export default languageEnum;
